

























































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

import { GlobalSearchOption, GlobalSearchCell } from '@/interfaces/global-search-option'
import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors } from '@/utils/snack'
import { getGlobalSearchCases } from '@/modules/Case/gql/case.gql'
import { getGlobalSearchAccounts } from '@/modules/Account/gql/account.gql'
import { Case } from '@/modules/Case/interfaces/case'
import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { getGlobalSearchContacts } from '@/modules/Contact/gql/contact.gql'
import { getGlobalSearchQuotes } from '@/modules/Quote/gql/quote.gql'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { getGlobalSearchPolicies } from '@/modules/Policy/gql/policy.gql'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { splitStringToArray } from '@/utils/split_string_to_array'
import { KeyOf } from 'ramda'

@Component({
})
export default class AppGlobalSearch extends Vue {
  @Prop({ type: [Number, String], default: 230 }) readonly width!: number | string
  @Prop({ default: 'Search...' }) readonly placeholder!: string

  model = ''

  outlined = false

  showList = false

  items: GlobalSearchOption[] = []

  queries = ['li', 'lin']

  modelList: string[] = []

  @Watch('model')
  onModelChanged (val: string) {
    this.modelList = this.splitStringToArray(val)
  }

  valueChangedHandler (val: string) {
    this.model = val
    this.showList = false
    this.items = []
  }

  submit () {
    this.items = []
    this.showList = true
    this.getList()
  }

  async getList () {
    await this.getAccount()
    await this.getContact()
    await Promise.all([
      this.getCase(),
      this.getQuote(),
      this.getPolicy()
    ])
  }

  async getCase () {
    const that = this
    const { modelList } = this
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getGlobalSearchCases,
        variables: {
          query: this.model,
          order: {
            orderBy: 'UPDATED_AT',
            asc: false
          },
          paging: {
            offset: 0,
            limit: 3
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      if (result.data.globalSearchCases.cases.length === 0) {
        return
      }
      const caseList: Case[] = result.data.globalSearchCases.cases
      const searchList: GlobalSearchCell[] = []
      that.$R.forEach((caseItem: any) => {
        Object.keys(caseItem).map(item => {
          for (var i = 0; i < modelList.length; i++) {
            const reg = new RegExp(modelList[i], 'ig')
            if (caseItem[item] && caseItem[item].search(reg) > -1 && item !== 'id' && item !== '__typename') {
              const caseCell: GlobalSearchCell = {
                title: caseItem.inquiryName,
                key: 'caseName',
                value: caseItem[item],
                id: caseItem.id,
                queries: modelList
              }
              searchList.push(caseCell)
              break
            }
          }
        })
      }, caseList)
      const item: GlobalSearchOption = {
        title: 'Case',
        searchList: searchList
      }
      that.items.push(item)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getAccount () {
    const that = this
    const { modelList } = this
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getGlobalSearchAccounts,
        variables: {
          query: this.model,
          order: {
            orderBy: 'UPDATED_AT',
            asc: false
          },
          paging: {
            offset: 0,
            limit: 3
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      if (result.data.globalSearchAccounts.accounts.length === 0) {
        return
      }
      const accountList: Account[] = result.data.globalSearchAccounts.accounts
      const searchList: GlobalSearchCell[] = []
      that.$R.forEach((accountItem: any) => {
        Object.keys(accountItem).map(item => {
          for (var i = 0; i < modelList.length; i++) {
            const reg = new RegExp(modelList[i], 'ig')
            if (accountItem[item] && accountItem[item].search(reg) > -1 && item !== 'id' && item !== '__typename') {
              const caseCell: GlobalSearchCell = {
                title: accountItem.name,
                key: item,
                value: accountItem[item],
                id: accountItem.id,
                queries: modelList
              }
              searchList.push(caseCell)
              break
            }
          }
        })
      }, accountList)
      const item: GlobalSearchOption = {
        title: 'Account',
        searchList: searchList
      }
      that.items.push(item)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getContact () {
    const that = this
    const { modelList } = this
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getGlobalSearchContacts,
        variables: {
          query: this.model,
          order: {
            orderBy: 'UPDATED_AT',
            asc: false
          },
          paging: {
            offset: 0,
            limit: 3
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      if (result.data.globalSearchContacts.contacts.length === 0) {
        return
      }
      const contactList: Account[] = result.data.globalSearchContacts.contacts
      const searchList: GlobalSearchCell[] = []
      that.$R.forEach((contactItem: any) => {
        Object.keys(contactItem).map(item => {
          for (var i = 0; i < modelList.length; i++) {
            const reg = new RegExp(modelList[i], 'ig')
            if (contactItem[item] && contactItem[item].search(reg) > -1 && item !== 'id' && item !== '__typename') {
              const caseCell: GlobalSearchCell = {
                title: contactItem.name,
                key: item,
                value: contactItem[item],
                id: contactItem.id,
                queries: modelList
              }
              searchList.push(caseCell)
              break
            }
          }
        })
      }, contactList)
      const item: GlobalSearchOption = {
        title: 'Contact',
        searchList: searchList
      }
      that.items.push(item)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getQuote () {
    const that = this
    const { modelList } = this
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getGlobalSearchQuotes,
        variables: {
          query: this.model,
          order: {
            orderBy: 'UPDATED_AT',
            asc: false
          },
          paging: {
            offset: 0,
            limit: 3
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      if (result.data.globalSearchQuotes.quotes.length === 0) {
        return
      }
      const quoteList: Quote[] = result.data.globalSearchQuotes.quotes
      const searchList: GlobalSearchCell[] = []
      that.$R.forEach((quoteItem: any) => {
        Object.keys(quoteItem).map(item => {
          for (var i = 0; i < modelList.length; i++) {
            const reg = new RegExp(modelList[i], 'ig')
            if (quoteItem[item] && quoteItem[item].search(reg) > -1 && item !== 'id' && item !== '__typename') {
              const caseCell: GlobalSearchCell = {
                title: quoteItem.name,
                key: 'quoteName',
                value: quoteItem[item],
                id: quoteItem.id,
                queries: modelList
              }
              searchList.push(caseCell)
              break
            }
          }
        })
      }, quoteList)
      const item: GlobalSearchOption = {
        title: 'Quote',
        searchList: searchList
      }
      that.items.push(item)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getPolicy () {
    const that = this
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getGlobalSearchPolicies,
        variables: {
          query: this.model,
          order: {
            orderBy: 'UPDATED_AT',
            asc: false
          },
          paging: {
            offset: 0,
            limit: 3
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      if (result.data.globalSearchPolicies.policies.length === 0) {
        return
      }
      const policyList: Policy[] = result.data.globalSearchPolicies.policies
      const searchList: GlobalSearchCell[] = []
      that.$R.forEach((policyItem: any) => {
        Object.keys(policyItem).map(item => {
          let modelList

          if (item === 'policyNumber') {
            modelList = this.restorePolicyNumberWords(policyItem.policyNumber.toLowerCase(), this.splitStringToArray(this.model).join('').toLowerCase())
          } else {
            modelList = this.modelList
          }

          let addressValue = ''

          if (item === 'additionalInfoStr') {
            const additionalInfo = JSON.parse(policyItem[item])
            if (additionalInfo.address1) {
              addressValue = additionalInfo.address2 ? additionalInfo.address1 + ', ' + additionalInfo.address2 : additionalInfo.address1
            } else if (additionalInfo.address2) {
              addressValue = additionalInfo.address2
            }
          }

          for (var i = 0; i < modelList.length; i++) {
            const reg = new RegExp(modelList[i], 'ig')
            if (policyItem[item] && policyItem[item].search(reg) > -1 && item !== 'id' && item !== '__typename') {
              const caseCell: GlobalSearchCell = {
                title: policyItem.policyName,
                key: item === 'additionalInfoStr' ? 'address' : item,
                value: item === 'additionalInfoStr'
                  ? addressValue
                  : policyItem[item],
                id: policyItem.id,
                queries: modelList
              }
              if (item === 'additionalInfoStr' && !addressValue) {
                break
              }
              searchList.push(caseCell)
              break
            }
          }
        })
      }, policyList)
      const item: GlobalSearchOption = {
        title: 'Policy',
        searchList: searchList
      }
      that.items.push(item)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  getRegex () {
    let regex = ''
    const modelList = this.splitStringToArray(this.model)
    for (var i = 0; i < modelList.length; i++) {
      regex += modelList[i] + `${i < modelList.length - 1 ? '.+' : ''}`
    }
    return regex
  }

  splitStringToArray = splitStringToArray

  restorePolicyNumberWords (policyNumber: string, search: string): string[] {
    const wordsList = this.splitStringToArray(policyNumber)
    let start = 0
    let end = 1
    let matched = ''
    for (const [i, word] of wordsList.entries()) {
      const test = matched + word
      if (search.indexOf(word) !== -1) {
        if (search.indexOf(test) !== -1) {
          matched = test
          end = i + 1
        } else {
          if (test.indexOf(search) !== -1) {
            return wordsList.slice(start, end)
          }
          matched = word
          start = i
        }
      } else {
        if (test.indexOf(search) !== -1) {
          return wordsList.slice(start, end)
        }
        start += 1
        end += 1
      }
      if (search === test) {
        break
      }
    }
    return wordsList.slice(start, end)
  }

  routeToDetail (item: GlobalSearchCell, type: string) {
    switch (type) {
      case 'Case':
        return {
          name: 'CaseDetailDetail',
          params: {
            id: item.id
          }
        }
      case 'Account':
        return {
          name: 'AccountDetailDetail',
          params: {
            id: item.id
          }
        }
      case 'Contact':
        return {
          name: 'ContactDetailDetail',
          params: {
            id: item.id
          }
        }
      case 'Quote':
        return {
          name: 'QuoteDetailDetail',
          params: {
            id: item.id
          }
        }
      case 'Policy':
        return {
          name: 'PolicyDetailDetail',
          params: {
            id: item.id
          }
        }
      default:
        break
    }
  }

  routeToViewAll (type: string) {
    switch (type) {
      case 'Case':
        return {
          name: 'CaseListWithSearchval',
          params: {
            type: 'all',
            search: this.model
          }
        }
      case 'Account':
        return {
          name: 'AccountsListWithSearchval',
          params: {
            search: this.model
          }
        }
      case 'Contact':
        return {
          name: 'ContactListWithSearchval',
          params: {
            type: 'search',
            search: this.model
          }
        }
      case 'Quote':
        return {
          name: 'QuotesListWithSearchval',
          params: {
            search: this.model
          }
        }
      case 'Policy':
        return {
          name: 'PoliciesListWithSearchval',
          params: {
            search: this.model
          }
        }
      default:
        break
    }
  }

  hideResult () {
    this.showList = false
  }
}
